module.exports = __webpack_public_path__ + "img/reticule2.e45bcb00.jpg";